import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import moment from 'moment'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { ChlorinePostDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWaterQualitySlice/ChlorineSlice';

export default function WaterQualityChlorinePagePopup(props) {

    const { RoleID, handleOnCloseClick, open, Flag, handleIsPost, item, EditIcon, apiFlag, rowData, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [ChlorineField, setChlorineField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        wardName: Flag === 'Update' ? rowData.wardName : '',
        junctionDetails: Flag === 'Update' ? rowData.junctionDetails : '',
        inletChlorine: Flag === 'Update' ? rowData.inletChlorine : '',
        outChlorine: Flag === 'Update' ? rowData.outChlorine : '',
        locationDetails: Flag === 'Update' ? rowData.locationDetails : '',
    })

    const handleChlorineField = (e) => {
        setChlorineField({ ...ChlorineField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            T_WS_WaterQualityChlorineID: Flag === 'Update' ? rowData.t_wS_WaterQualityChlorineID : '0',
            T_Distri_WaterQualityChlorineID: Flag === 'Update' ? rowData.t_Distri_WaterQualityChlorineID : '0',
            InletChlorine: ChlorineField.inletChlorine,
            OutChlorine: ChlorineField.outChlorine,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(ChlorinePostDataAPI({ data }))

    }

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Quality-Chlorine</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                        <input type="date" className="form-control"
                                            name='readingDate'
                                            aria-describedby="emailHelp"
                                            disabled
                                            value={ChlorineField.readingDate}
                                            onChange={(e) => handleChlorineField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name </b></label>
                                        <input type="text" className="form-control"
                                            name='wardName'
                                            aria-describedby="emailHelp"
                                            disabled
                                            value={ChlorineField.wardName}
                                            onChange={(e) => handleChlorineField(e)}
                                        />
                                    </div>
                                </div>

                                {
                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Location Name </b></label>
                                                    <input type="text" className="form-control"
                                                        name='locationDetails'
                                                        aria-describedby="emailHelp"
                                                        disabled
                                                        value={ChlorineField.locationDetails}
                                                        onChange={(e) => handleChlorineField(e)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <div className="col-12 col-md-6 col-lg-6" >
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Location Name </b></label>
                                                <input type="text" className="form-control"
                                                    name='junctionDetails'
                                                    aria-describedby="emailHelp"
                                                    disabled
                                                    value={ChlorineField.junctionDetails}
                                                    onChange={(e) => handleChlorineField(e)}
                                                />
                                            </div>
                                        </div>
                                }



                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Inlet </b></label>
                                        <input type="text" className="form-control"
                                            name='inletChlorine'
                                            aria-describedby="emailHelp"
                                            value={ChlorineField.inletChlorine}
                                            onChange={(e) => handleChlorineField(e)}
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Outlet </b></label>
                                        <input type="text" className="form-control"
                                            name='outChlorine'
                                            aria-describedby="emailHelp"
                                            value={ChlorineField.outChlorine}
                                            onChange={(e) => handleChlorineField(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-md-4 pt-4">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}